import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Skill Name',
    field: 'skillsetName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Skill Set Code',
    field: 'skillsetCode',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Note',
    field: 'notes',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'status',
    filter: 'text',
  },
];
